import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={{ background: "#060F1E", fontFamily: "'Barlow', sans-serif", borderTop: "3px solid #e8a800" }}>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=Barlow:wght@400;500;600&display=swap" rel="stylesheet" />

      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "64px 24px 40px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 48 }}>

        {/* Brand */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
            <div style={{ width: 48, height: 48, background: "#1a6ab5", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 13, color: "#fff", fontFamily: "'Barlow Condensed', sans-serif" }}>UEBC</div>
            <div>
              <div style={{ color: "#fff", fontWeight: 800, fontSize: 14, letterSpacing: 1.5, textTransform: "uppercase", fontFamily: "'Barlow Condensed', sans-serif" }}>Unique Engineers</div>
              <div style={{ color: "#e8a800", fontWeight: 600, fontSize: 10, letterSpacing: 2, textTransform: "uppercase" }}>Building Contracting LLC</div>
            </div>
          </div>
          <p style={{ color: "#6a84a0", fontSize: 14, lineHeight: 1.8, margin: "0 0 20px" }}>Established in UAE since 2014. Providing professional building maintenance & contracting services across Dubai and the UAE.</p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 style={{ color: "#e8a800", fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, letterSpacing: 2, textTransform: "uppercase", marginBottom: 20, marginTop: 0 }}>Quick Links</h4>
          {[
            { label: "Home", to: "/" },
            { label: "About Us", to: "/about" },
            { label: "Our Services", to: "/services" },
            { label: "Contact Us", to: "/contact" },
          ].map(link => (
            <Link key={link.label} to={link.to}
              style={{ display: "flex", alignItems: "center", gap: 8, color: "#6a84a0", textDecoration: "none", fontSize: 14, padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.05)", transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "#e8a800"}
              onMouseLeave={e => e.currentTarget.style.color = "#6a84a0"}
            >
              <svg width="8" height="8" viewBox="0 0 24 24" fill="#e8a800"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              {link.label}
            </Link>
          ))}
        </div>

        {/* Services */}
        <div>
          <h4 style={{ color: "#e8a800", fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, letterSpacing: 2, textTransform: "uppercase", marginBottom: 20, marginTop: 0 }}>Core Services</h4>
          {["Building Contracting", "Plumbing & Sanitary", "Electrical Works", "Solar Energy", "Painting Works", "Floor & Wall Tiling"].map(s => (
            <div key={s} style={{ display: "flex", alignItems: "center", gap: 8, color: "#6a84a0", fontSize: 14, padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              <svg width="8" height="8" viewBox="0 0 24 24" fill="#e8a800"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              {s}
            </div>
          ))}
        </div>

        {/* Contact */}
        <div>
          <h4 style={{ color: "#e8a800", fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, letterSpacing: 2, textTransform: "uppercase", marginBottom: 20, marginTop: 0 }}>Contact Us</h4>
          {[
            {
              icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e8a800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>),
              text: "Ras Al Khor Industrial Area 1, Dubai, UAE"
            },
            {
              icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e8a800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37 2 2 0 0 1 3.57 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.74a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>),
              text: "050 7861818"
            },
            
            {
              icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e8a800" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>),
              text: "info@uniqueengineers.ae"
            },
          ].map(({ icon, text }) => (
            <div key={text} style={{ display: "flex", gap: 10, alignItems: "flex-start", marginBottom: 14 }}>
              <span style={{ flexShrink: 0, marginTop: 2 }}>{icon}</span>
              <span style={{ color: "#6a84a0", fontSize: 13.5, lineHeight: 1.5 }}>{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "20px 24px", display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", maxWidth: 1200, margin: "0 auto", gap: 12 }}>
        <p style={{ color: "#3a5570", fontSize: 13, margin: 0 }}>
          © {new Date().getFullYear()} Unique Engineers Building Contracting LLC. All Rights Reserved.
        </p>
        <p style={{ color: "#3a5570", fontSize: 13, margin: 0 }}>
          P.O. BOX 390694, Dubai, UAE
        </p>
      </div>
    </footer>
  );
}